import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 py-8" data-id="element-70">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center" data-id="element-71">
        <p className="font-nunito text-sm text-gray-400" data-id="element-72">
          © 2026 Aprendo Jugando · Learning Through Play. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}